export default __webpack_public_path__ + "static/media/Message-App.8a23a70d.PNG";